// extracted by mini-css-extract-plugin
module.exports = {"col":"TagMonsterChild_col__1aa_n"};